export const roles = {
  superAdmin: 'MediSyncAdmin',
  physician: 'Physician',
  author: 'author',
  patient: 'Patient',
  other: 'other',
  hcp: 'HCP',
  editor: 'editor'
}
